import { writable } from "svelte/store";

export const radioCheck = writable("demandNorm");
export const isCalculate = writable(true);
export const totalPopulation = writable(0);
export const totalJobs = writable(0);
export const totalPopulationDistricts = writable(0);
export const totalJobsDistricts = writable(0);
export const totalPopulation_OZP_TZ = writable(0);
export const totalJobs_OZP_TZ = writable(0);

export const averageAge = writable(0);
export const averageCommute = writable(0);
export const averageWalk = writable(0);
export const averageDeprivation = writable(0);
export const LoadingBarValue = writable(0);
export const InsightsRadioCheck = writable("SP");
export const drawClicked = writable(false);
export const pointClicked = writable(false);
export const bufferZoneValue = writable(2);
export const bufferLocationValue = writable(2);
export const lpCoords = writable(null);
export const topZonesStore = writable(0);
export const top10Count = writable(0);
export const DistanceFromZonesSP = writable(0);
export const ParkingDensitySP = writable(0);
export const drawingMode = writable(false);
export const levelAccess = writable("level2");
export const districtAccess = writable("");
export const districtFeatures = writable({})

export const serverURL = writable(
  "https://trigs-back-final-861958839302.europe-west1.run.app/"
);
